import JSZip from 'jszip';
import ExcelJS from 'exceljs';

const fixSpreadsheetNamespace = (xml) => {
    return xml
        .replace(
            /xmlns:x="http:\/\/schemas\.openxmlformats\.org\/spreadsheetml\/2006\/main"/,
            'xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"',
        )
        .replace(/<(\/?)\w+:/g, '<$1');
};

const workbookCache = new WeakMap();

const loadWorkbookFixed = async (file) => {
    if (workbookCache.has(file)) {
        return workbookCache.get(file);
    }

    const zip = await JSZip.loadAsync(await file.arrayBuffer());
    const newZip = new JSZip();

    for (const [path, entry] of Object.entries(zip.files)) {
        if (path.endsWith('.xml')) {
            let xml = await entry.async('string');

            if (
                path === 'xl/workbook.xml' ||
                path === 'docProps/app.xml' ||
                path.includes('xl/worksheets/') ||
                path.includes('xl/sharedStrings.xml') ||
                path.includes('xl/styles.xml')
            ) {
                xml = fixSpreadsheetNamespace(xml);
            }
            newZip.file(path, xml);
        } else {
            newZip.file(path, await entry.async('uint8array'));
        }
    }

    const buffer = await newZip.generateAsync({ type: 'arraybuffer' });

    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(buffer);

    workbookCache.set(file, workbook);
    return workbook;
};

const getCellValue = (cell) => {
    const val = cell.value;
    if (val === null || val === undefined) return '';
    if (val instanceof Date) {
        const hasTime = val.getUTCHours() !== 0 || val.getUTCMinutes() !== 0 || val.getUTCSeconds() !== 0;
        return hasTime ? val.toISOString().replace('T', ' ').slice(0, 19) : val.toISOString().split('T')[0];
    }
    if (typeof val === 'object') {
        if (val.richText) return val.richText.map((r) => r.text).join('');
        if (val.text !== undefined) return String(val.text); // hyperlink
        if (val.result !== undefined) return String(val.result); // formula result
        if (val.error) return '';
    }
    return String(val);
};

export const getXlsxSheetNames = async (file) => {
    const workbook = await loadWorkbookFixed(file);
    return workbook.worksheets.map((ws) => ws.name);
};

export const readXlsxSheetAsRows = async (file, sheetName) => {
    const workbook = await loadWorkbookFixed(file);

    const worksheet = workbook.getWorksheet(sheetName);
    if (!worksheet) {
        return null;
    }

    const colCount = worksheet.columnCount;
    const rows = [];
    worksheet.eachRow((row) => {
        const rowData = [];
        for (let c = 1; c <= colCount; c++) {
            rowData.push(getCellValue(row.getCell(c)));
        }
        rows.push(rowData);
    });
    return rows;
};
